// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invent-logo {
  width: 150px;
  margin: 0 auto;
  display: block;
}

.custom-logo {
  width: 600px;
  margin: 0 auto;
  display: block;
  position: relative;
}

.login-title {
  color: var(--text-color-2nd-login-desktop);
  text-align: center;
}

.custom-input {
  color: var(--text-color-2nd-login-desktop);
  padding-left: 10px !important;
  height: 3rem;
  margin: auto;
  display: inline-block;
  border-radius: 5px;
}

.custom-btn {
  color: rgba(0, 0, 0, 0.65);
  background: #ffffff;
  height: 41px;
  width: 100%;
}

.border-n-shadow {
  border-radius: 5px;
  box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.39);
}

.forgot-password {
  font-size: 0.8em;
  padding-left: 3px;
}

.invalid-code {
  font-size: 0.8em;
  color: #dd2222;
  font-weight: bold;
  text-align: center;
}

.timer {
  font-size: 0.8em;
  font-weight: bold;
  text-align: center;
}

.term-conditions {
  background-color: transparent;
  border: none;
  font-size: 0.78em;
  display: flex;
  align-items: center;
  color: var(--text-color-2nd-login-desktop);
  font-family: "Roobert-Regular";
}
.term-conditions a {
  font-weight: 600;
  color: var(--text-color-2nd-login-desktop) !important;
}

.space-condition {
  padding-left: 10px;
}

.conditions-class {
  font-size: 1em;
  color: #2979FF;
  margin-top: -5px;
  padding: 0;
}

.footer {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
}

.footer-txt {
  font-size: 0.7em;
}

.btn-shaped {
  text-transform: uppercase;
  border-radius: 5px;
  font-size: 0.9em;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.fb-btn,
.google-btn,
.twitter-btn,
.yahoo-btn,
.microsoft-btn {
  margin-bottom: 2px;
}

.fb-btn {
  background: #4267B2;
  color: #ffffff;
}

.google-btn {
  background: #ffffff;
  color: #757575;
  border: 0.3px solid #757575;
}

.twitter-btn {
  background: #34A1F2;
  color: #ffffff;
}

.yahoo-btn {
  background: #432A90;
  color: #ffffff;
}

.microsoft-btn {
  background: #37A4EF;
  color: #ffffff;
}

.btn-img {
  width: 13px;
}

.input-item {
  border: 1.5px solid var(--text-color-2nd-login-desktop);
  color: var(--text-color-2nd-login-desktop);
  border-radius: var(--border-radius-md);
  --background: var(--input-bg);
  --border-color: transparent;
  --highlight-color-focused: transparent;
  --inner-padding-end: 8px;
  --padding-start: 16px;
  --min-height: 56px;
  transition: border-color var(--transition-normal);
}

.input-item.ion-focused {
  border-color: var(--input-focus-border-color) !important;
}

.input-item.has-error {
  border-color: var(--input-error-color) !important;
  box-shadow: 0 0 0 1px var(--input-error-color);
}

.input-item.is-valid {
  border-color: var(--input-success-color) !important;
}

.input-label-text {
  color: var(--label-login-color);
}

.icon {
  right: 0;
  position: absolute;
  color: var(--valid-btn-bg-color);
  z-index: 9999;
}

.btn-default {
  height: 3rem;
  width: 100%;
  max-width: none;
  font-family: "Roobert-Bold";
}

.btn-default .align-loader {
  min-height: 0;
  margin: 0;
}

ion-checkbox {
  width: 33px;
  height: 21px;
  --border-radius: 4px;
}

.forgot-password {
  font-size: 14px;
  padding-left: 3px;
  text-decoration: underline;
  font-family: "Roobert-Regular";
  color: var(--text-color-2nd-login-desktop);
  cursor: pointer;
}

a {
  cursor: pointer;
}

.img-bg {
  position: fixed;
  height: 100vh;
  width: 100%;
  background-size: 100% 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/public-login/public-login.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,cAAA;EACA,cAAA;AACJ;;AAEA;EACI,YAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AACJ;;AAEA;EACI,0CAAA;EAIA,kBAAA;AAFJ;;AAKA;EACI,0CAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,0BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAFJ;;AAKA;EACI,kBAAA;EAGA,+CAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,6BAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,8BAAA;AAFJ;AAGI;EACI,gBAAA;EACA,qDAAA;AADR;;AAKA;EACI,kBAAA;AAFJ;;AAKA;EACI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;AAFJ;;AAKA;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAFJ;;AAKA;;;;;EAKI,kBAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,cAAA;EACA,2BAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,WAAA;AAFJ;;AAIA;EACI,uDAAA;EACA,0CAAA;EACA,sCAAA;EACA,6BAAA;EACA,2BAAA;EACA,sCAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iDAAA;AADJ;;AAIA;EACI,wDAAA;AADJ;;AAIA;EACI,iDAAA;EACA,8CAAA;AADJ;;AAIA;EACI,mDAAA;AADJ;;AAGA;EAEI,+BAAA;AADJ;;AAGA;EACI,QAAA;EACA,kBAAA;EACA,gCAAA;EACA,aAAA;AAAJ;;AAEA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,2BAAA;AACJ;;AAEA;EACI,aAAA;EACA,SAAA;AACJ;;AACA;EACI,WAAA;EACA,YAAA;EACA,oBAAA;AAEJ;;AAAA;EACI,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,8BAAA;EACA,0CAAA;EACA,eAAA;AAGJ;;AAAA;EACI,eAAA;AAGJ;;AAAA;EACI,eAAA;EACA,aAAA;EACA,WAAA;EACA,0BAAA;AAGJ","sourcesContent":[".invent-logo {\n    width: 150px;\n    margin: 0 auto;\n    display: block;\n}\n\n.custom-logo {\n    width: 600px;\n    margin: 0 auto;\n    display: block;\n    position: relative;\n}\n\n.login-title {\n    color: var(--text-color-2nd-login-desktop);\n    // font-weight: bold;\n    // font-size: .9em;\n    // text-transform: uppercase;\n    text-align: center;\n}\n\n.custom-input {\n    color: var(--text-color-2nd-login-desktop);\n    padding-left: 10px !important;\n    height: 3rem;\n    margin: auto;\n    display: inline-block;\n    border-radius: 5px;\n}\n\n.custom-btn {\n    color: rgba(0, 0, 0, 0.65);\n    background: #ffffff;\n    height: 41px;\n    width: 100%;\n}\n\n.border-n-shadow {\n    border-radius: 5px;\n    -webkit-box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.39);\n    -moz-box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.39);\n    box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.39);\n}\n\n.forgot-password {\n    font-size: .8em;\n    padding-left: 3px;\n}\n\n.invalid-code {\n    font-size: 0.8em;\n    color: #dd2222;\n    font-weight: bold;\n    text-align: center;\n}\n\n.timer {\n    font-size: 0.8em;\n    font-weight: bold;\n    text-align: center;\n}\n\n.term-conditions {\n    background-color: transparent;\n    border: none;\n    font-size: .78em;\n    display: flex;\n    align-items: center;\n    color: var(--text-color-2nd-login-desktop);\n    font-family: 'Roobert-Regular';\n    a{\n        font-weight: 600;\n        color: var(--text-color-2nd-login-desktop) !important;\n    }\n}\n\n.space-condition {\n    padding-left: 10px;\n}\n\n.conditions-class {\n    font-size: 1em;\n    color: #2979FF;\n    margin-top: -5px;\n    padding: 0;\n}\n\n.footer {\n    width: 100%;\n    text-align: center;\n    position: absolute;\n    bottom: 0;\n}\n\n.footer-txt {\n    font-size: .7em;\n}\n\n.btn-shaped {\n    text-transform: uppercase;\n    border-radius: 5px;\n    font-size: .9em;\n    padding-left: 20px;\n    padding-right: 20px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n.fb-btn,\n.google-btn,\n.twitter-btn,\n.yahoo-btn,\n.microsoft-btn {\n    margin-bottom: 2px;\n}\n\n.fb-btn {\n    background: #4267B2;\n    color: #ffffff;\n}\n\n.google-btn {\n    background: #ffffff;\n    color: #757575;\n    border: 0.3px solid #757575;\n}\n\n.twitter-btn {\n    background: #34A1F2;\n    color: #ffffff;\n}\n\n.yahoo-btn {\n    background: #432A90;\n    color: #ffffff;\n}\n\n.microsoft-btn {\n    background: #37A4EF;\n    color: #ffffff;\n}\n\n.btn-img {\n    width: 13px;\n}\n.input-item { \n    border: 1.5px solid var(--text-color-2nd-login-desktop);\n    color: var(--text-color-2nd-login-desktop);\n    border-radius: var(--border-radius-md);\n    --background: var(--input-bg);\n    --border-color: transparent;\n    --highlight-color-focused: transparent;\n    --inner-padding-end: 8px;\n    --padding-start: 16px;\n    --min-height: 56px;\n    transition: border-color var(--transition-normal);\n}\n\n.input-item.ion-focused {\n    border-color: var(--input-focus-border-color) !important;\n}\n\n.input-item.has-error {\n    border-color: var(--input-error-color) !important;\n    box-shadow: 0 0 0 1px var(--input-error-color);\n}\n\n.input-item.is-valid {\n    border-color: var(--input-success-color) !important;\n}\n.input-label-text {\n    // color: #908B99;\n    color: var(--label-login-color);\n}\n.icon{\n    right: 0;\n    position: absolute;\n    color: var(--valid-btn-bg-color);\n    z-index: 9999;\n}\n.btn-default{\n    height: 3rem;\n    width: 100%;\n    max-width: none;\n    font-family: 'Roobert-Bold';\n}\n\n.btn-default .align-loader{\n    min-height: 0;\n    margin: 0;\n}\nion-checkbox{\n    width: 33px;\n    height: 21px;\n    --border-radius: 4px;\n}\n.forgot-password {\n    font-size: 14px;\n    padding-left: 3px;\n    text-decoration: underline;\n    font-family: 'Roobert-Regular';\n    color: var(--text-color-2nd-login-desktop);\n    cursor: pointer;\n}\n\na{\n    cursor: pointer;\n}\n\n.img-bg{\n    position: fixed;\n    height: 100vh;\n    width: 100%;\n    background-size: 100% 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
